export const BD_GET_INCOTERMCITY_LISTING = "BD_GET_INCOTERMCITY_LISTING"
export const BD_GET_INCOTERMCITY_LISTING_SUCCESS = "BD_GET_INCOTERMCITY_LISTING_SUCCESS"
export const BD_GET_INCOTERMCITY_LISTING_FAILED = "BD_GET_INCOTERMCITY_LISTING_FAILED"